import SportsIcon from "@material-ui/icons/Sports";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleIcon from "@material-ui/icons/People";

import { AppResource } from "../../../types/resource.types";
import { AcademyPackagesCreate, AcademyPackagesEdit, AcademyPackagesList } from "../../Academies/Packages";
import AcademyDashboard from "./Dashboard";
import { TrainersList, TrainersCreate, TrainerEdit } from "../../Academies/Trainers";
import AccountSettings from "../../AccountSettings";
import Chat from "../../Chat";
import AcademyFullNotificationList from "../../Academies/AcademyNotifications/AcademyFullNotificationList";
import { AcademyMembersList } from "../../Academies/Members";
import AcademyProfile from "../../Profiles/AcademyProfile";
import { AcademiesReviewsList } from "../../Academies/Reviews";

export const academyAccount = {
  resources: [
    <Resource
      name={AppResource.packages}
      list={AcademyPackagesList}
      edit={AcademyPackagesEdit}
      create={AcademyPackagesCreate}
      icon={BusinessIcon}
      options={{
        label: "Packages",
      }}
    />,
    <Resource
      name={AppResource.trainers}
      list={TrainersList}
      edit={TrainerEdit}
      create={TrainersCreate}
      icon={EmojiPeopleIcon}
      options={{
        label: "Trainers",
      }}
    />,
    <Resource
      name={AppResource.subscribedAcademies}
      list={AcademyMembersList}
      icon={PeopleIcon}
      options={{
        label: "Members",
      }}
    />,
    <Resource
      name={AppResource.academyReviews}
      list={AcademiesReviewsList}
      icon={SportsIcon}
      options={{
        label: "Reviews",
      }}
    />,
    <Resource name={AppResource.clients} />,
    <Resource name={AppResource.sportTypes} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.notifications}`} component={AcademyFullNotificationList} />,
    <Route exact path={`/${AppResource.profile}`} component={AcademyProfile} />,
  ],
  dashboard: AcademyDashboard,
};
